import {Axios} from "axios";
import {z} from "zod";
import {
  Ticket,
  Event,
  EventQuestion,
  LeadersBulletinData,
} from "../../models/Models";

const getLeadersBulletinRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
  }),
});

type GetLeadersBulletinRequestPayload = z.infer<
  typeof getLeadersBulletinRequestSchema
>;

export type LeadersBulletinApiResponse = {
  data: {
    emdOrderCounts: LeadersBulletinData;
    emailOrderCounts: LeadersBulletinData;
  };
  message: string;
};

export type LeadersBulletinDataApiResponse = {
  emdOrderCounts: LeadersBulletinData;
  emailOrderCounts: LeadersBulletinData;
};

export async function getLeadersBulletin(
  requestPayload: GetLeadersBulletinRequestPayload,
  axiosInstance: Axios
): Promise<LeadersBulletinDataApiResponse> {
  getLeadersBulletinRequestSchema.parse(requestPayload);
  const response = await axiosInstance.get(
    `/event/${requestPayload.data.eventId}/leadersBulletin`
  );
  return response.data.data;
}
